import React from 'react';
import { Col } from 'react-bootstrap';

const FormCol12 = (props) => (
  <Col sm={12} lg={12} xl={12} {...props}>
    {props.children}
  </Col>
);

export default FormCol12;

